export default function Dashboard() {
  return (
    <div>
      <h1 className="text-xl color-red">Dashboard</h1>
    </div>
  );
}
